import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  serviceType: {
    description: '',
    code: '',
    type: '',
  },
};

export const createServiceType = createSlice({
  name: 'createServiceType',
  initialState,
  reducers: {
    updateServiceTypeInfo: (state, action) => {
      state.serviceType = action.payload;
    },
    updateServiceTypeInfoField: (state, action) => {
      const { field, value } = action.payload;
      state.serviceType[field] = value;
    },
    clearServiceTypeInfo: (state) => {
      state.serviceType = initialState.serviceType;
    },
  },
});

export const serviceTypeDetailSelector = (state) => state.createServiceType.serviceType;
export const {
  updateServiceTypeInfo,
  updateServiceTypeInfoField,
  clearServiceTypeInfo,
} = createServiceType.actions;

export const createServiceTypeReducer = createServiceType.reducer;
export const createServiceTypeReducerName = createServiceType.name;

export default createServiceType.reducer;